import { render, staticRenderFns } from "./delivery-template-import.vue?vue&type=template&id=6571ce7a"
import script from "./delivery-template-import.vue?vue&type=script&lang=js"
export * from "./delivery-template-import.vue?vue&type=script&lang=js"
import style0 from "./delivery-template-import.vue?vue&type=style&index=0&id=6571ce7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports